import { useEffect, useRef } from "react";
import {
  CLEARBOOK_CUSTOMER,
  CLEARBOOK_API_KEY,
  CLEARBOOK_EMBED_SCRIPT,
} from "@/lib/clearbook";

/**
 * Renders Clearbook's contact-form embed.
 *
 * The embed script (`https://api.clearbook.dk/embed.js`) is loaded exactly
 * ONCE per page — subsequent mounts (SPA route changes) reuse the same
 * script and let Clearbook re-hydrate the container.
 *
 * No fixed height is applied so the form can grow with its content and stay
 * responsive on both mobile and desktop.
 */
export const ClearbookContactEmbed = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (document.querySelector(`script[src="${CLEARBOOK_EMBED_SCRIPT}"]`)) {
      // Script already present — Clearbook's own logic will hydrate the container.
      return;
    }
    const s = document.createElement("script");
    s.src = CLEARBOOK_EMBED_SCRIPT;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div
      ref={containerRef}
      id="clearbook-embed"
      data-customer={CLEARBOOK_CUSTOMER}
      data-api-key={CLEARBOOK_API_KEY}
      data-type="contact"
      data-testid="clearbook-contact-embed"
      className="w-full"
    />
  );
};
